"use client";

import { useContext } from "react";

import { consentContext } from "../lib/consentContext";

export const useConsentContext = () => useContext(consentContext);
